import React from 'react';

const FormInput = ({
  label,
  name,
  value,
  onChange,
  onFocus,
  onBlur,
  type = 'text',
  required = false,
  className = '',
  placeholder = '',
  step,
  min,
  maxLength,
  disabled = false,
  autocomplete
}) => {
  return (
    <div className={className}>
      <label htmlFor={name} className="block text-sm font-medium text-gray-700 mb-2">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <input
        type={type}
        name={name}
        id={name}
        value={value || ''}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        placeholder={placeholder}
        step={step}
        min={min}
        maxLength={maxLength}
        disabled={disabled}
        autoComplete={autocomplete}
        className={`block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md ${
          disabled ? 'bg-gray-100 cursor-not-allowed' : ''
        }`}
      />
    </div>
  );
};

export default FormInput;
